import { Combobox, type ComboboxOption } from '@library/components/selects';
import type {
  MemberTransactionFiltersParam,
  MemberTransactionFilters as MemberTransactionFiltersType
} from '@library/types/members/memberTransactions';
import { useCallback, useMemo, useState } from 'react';
import { PrizepicksDatePicker } from '@library/components/datePicker';
import { ResetIconButton } from '@library/components/buttons';

export interface MemberTransactionFiltersProps {
  memberTransactionFilters: MemberTransactionFiltersType;
  onChangeMemberTransactionsFilter: ({
    key,
    value
  }: MemberTransactionFiltersParam) => void;
  onResetMemberTransactionFilters: () => void;
  transactionTypeOptions: Array<ComboboxOption>;
}

export const MemberTransactionFilters = ({
  memberTransactionFilters,
  onChangeMemberTransactionsFilter,
  onResetMemberTransactionFilters,
  transactionTypeOptions
}: MemberTransactionFiltersProps) => {
  const [transactionDatePickerOpen, setTransactionDatePickerOpen] =
    useState(false);

  const { transactionDate, transactionTypes: selectedTransactionTypes } =
    memberTransactionFilters;

  const selectedTransactionTypeOptions = useMemo(() => {
    return transactionTypeOptions.filter((option) =>
      selectedTransactionTypes.includes(option.value as string)
    );
  }, [selectedTransactionTypes, transactionTypeOptions]);

  const handleTransactionTypeChange = useCallback(
    (options: Array<ComboboxOption> | null) =>
      onChangeMemberTransactionsFilter({
        key: 'transactionTypes',
        value: options || []
      }),
    [onChangeMemberTransactionsFilter]
  );

  return (
    <div className="flex items-start gap-6 pb-4">
      <div className="w-60 shrink-0">
        <PrizepicksDatePicker
          disabled={false}
          handleChange={(date) =>
            onChangeMemberTransactionsFilter({
              key: 'transactionDate',
              value: date || undefined
            })
          }
          minDate={undefined}
          open={transactionDatePickerOpen}
          placeholder="Transaction Date"
          setOpen={setTransactionDatePickerOpen}
          value={transactionDate}
        />
      </div>
      <Combobox
        allowSelectAll
        id="Transaction-type"
        isClearable
        isMulti
        onChange={handleTransactionTypeChange}
        options={transactionTypeOptions}
        placeholder="Select Transaction Types..."
        value={selectedTransactionTypeOptions}
        valueClassName={
          selectedTransactionTypeOptions.length ? 'py-[7px]' : 'py-[11px]'
        }
      />
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 pt-3"
        disabled={false}
        label="Reset Filters"
        onClick={onResetMemberTransactionFilters}
      />
    </div>
  );
};
